import './CountrySearch.css'
import React, { useEffect, useState } from 'react'
import Flag from 'react-world-flags'
import TransparentBlue from '../assets/TransparentBlue.svg'
import SearchIcon from '../assets/SearchGlass.svg'
import NoCountries from '../assets/NoCountries.svg'
import localhostSettings from '../local'
import { useTranslation } from 'react-i18next'
import useCountryStore from '../store/useCountryStore'
import close from '../assets/Cross.svg'
import FilterCountries from '../FilterCountries'
import { READMORE } from '../constants'

const CountrySearch: React.FC = () => {
  const [filteredCountries, setFilteredCountries] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [expandedCountry, setExpandedCountry] = useState<string | null>(null)
  const { data, fetchData }: any = useCountryStore();

  const dataSet = data?.getCategoryByID?.metaExtension?.dataSet || [];
  const roamingEntry = dataSet.find(
    (item: any) => item?.genericData?.valueSet?.roamingcountries
  );
  const roamingCountries =
    roamingEntry?.genericData?.valueSet?.roamingcountries
      ?.filter(
        (country: any, index: number, self: any[]) =>
          index === self.findIndex((c: any) => c.countryEnglish === country.countryEnglish)
      ) ?? []
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const isRTL = localhostSettings.isRTL()
  const { t } = useTranslation()
  const highlightMatch = (text: string, search: string) => {
    if (!search) return text

    const regex = new RegExp(`(${search})`, 'gi')
    const parts = text.split(regex)

    return parts.map((part, index) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span key={index} className="country-highlight">
          {part}
        </span>
      ) : (
        part
      )
    )
  }
 

  return (
    <>
      {' '}
      <div className='subtitle-text'>{t('Pay_As_You_Go_Roaming_Rates')}</div>
      <div className="payAsYouGo-subTitle">
        {t('When_not_using_a_bundle')}
      </div>
      <div className="country-search-wrapper">
         <FilterCountries
              data={roamingCountries}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              onFilter={setFilteredCountries}
            />

        {searchTerm && (
          <div className="country-s-list">
            {filteredCountries.length === 0 ? (

              <div className='no-country-option'>
                <div className='country-summary'>
                  <div className='country-left'>
                    <img
                      src={NoCountries}
                      alt="NoCountries"
                      style={{
                        width: 40,
                        height: 40,
                        marginRight: 8,
                        borderRadius: '50%',
                        objectFit: 'cover',
                      }}
                    />
                    <span className='no-country-name'>
                      {t("No_countries_found")}
                    </span>
                  </div>
                </div>
              </div>

            ) : (
              filteredCountries.map((country: any) => {
                const isExpanded = expandedCountry === country.countryEnglish
                return (
                  <div key={country.countryEnglish} className="country-s-option">
                    <div
                      className="country-summary"
                      onClick={() => setExpandedCountry(isExpanded ? null : country.countryEnglish)}
                    >
                      <div className="country-left">
                        <Flag
                          code={country.id}
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            objectFit: 'cover',
                            marginRight: 8,
                          }}
                        />
                        <span className="country-name">
                          {highlightMatch(
                            isRTL ? country.countryArabic : country.countryEnglish,
                            searchTerm
                          )}
                        </span>

                      </div>
                      <div className="toggle-icon">
                        <img
                          src={TransparentBlue}
                          alt={isExpanded ? 'Collapse' : 'Expand'}
                          className={`toggle-arrow ${isExpanded ? 'expanded' : ''}`}
                        />
                      </div>
                    </div>

                    {isExpanded && (
                      <div className="country-s-details">
                        <div className="rate-row">
                          <div>
                            {t("Local_calls")}
                            <br />
                            <strong>{t("SAR")} {country?.paygRates?.[0]?.localCall ?? 0} {t("SAR/min")}</strong>
                          </div>
                          <div>
                            {t("International_Calls")}
                            <br />
                            <strong> {t("SAR")} {country?.paygRates?.[0]?.internationalCalls ?? 0} {t("SAR/min")}</strong>
                          </div>
                          <div>
                            {t("Calls_to_KSA")}
                            <br />
                            <strong>{t("SAR")} {country?.paygRates?.[0]?.callToKSA ?? 0} {t("SAR/min")}</strong>
                          </div>
                          <div>
                            {t("Received_calls")}
                            <br />
                            <strong>{t("SAR")} {country?.paygRates?.[0]?.receivedCalls ?? 0} {t("SAR/min")}</strong>
                          </div>
                          <div>
                            {t("Receive_SMS")}
                            <br />
                            <strong>{country?.paygRates?.[0]?.receivedSMS ?? ''}</strong>
                          </div>
                          <div>
                            {t("Send_SMS")}
                            <br />
                            <strong>{t("SAR")} {country?.paygRates?.[0]?.sendSMS ?? 0} </strong>
                          </div>
                          <div>
                            {t("Internet_&_MMS")}
                            <br />
                            <strong>{t("SAR")} {country?.paygRates?.[0]?.internetMMS ?? 0} {t("SAR/MB")}</strong>
                          </div>
                        </div>
                        <div className="s-terms">
                          <p >
                            {t("T&C_summary")}{' '}
                            <a href={READMORE} className="link-readMore">
                              {t("Read_more")}
                            </a>
                          </p>
                        </div>

                      </div>
                    )}
                  </div>
                )
              })
            )}
          </div>
        )}
      </div>
    </>
  )
}

export default CountrySearch
